import SiteInfoList from './SiteInfoList';

export default SiteInfoList;
